/**
 * Durable preference wins. A valid database-backed `last_active_instance_id`
 * is authoritative over browser-local state; localStorage is only a fallback
 * when the durable preference is absent or no longer valid for this user.
 */
export function resolvePreferredInstanceId(
  instances: Array<{ id: string }>,
  dbPreferredInstanceId: string | null | undefined,
  localInstanceId: string | null | undefined,
): string | null {
  if (!instances.length) return null;
  const dbTarget = dbPreferredInstanceId ? instances.find(i => i.id === dbPreferredInstanceId) : null;
  const localTarget = localInstanceId ? instances.find(i => i.id === localInstanceId) : null;
  return (dbTarget ?? localTarget ?? instances[0]).id;
}
